import { MARGIN_BETWEEN_BRANCH_NODES } from 'automation-ui-flow-core/canvas/graphConstants';
import { calculateNodeWidthMultipliers } from 'automation-ui-directed-graph/utils/calculateNodeWidthMultipliers';
const getNodeWrapperWidth = (nodeId, directedGraph) => {
  const nodeWidths = calculateNodeWidthMultipliers(directedGraph.getEdges());
  const widthMultiplier = nodeId && nodeWidths[nodeId] || 1;
  const nodeWrapperWidth = widthMultiplier * directedGraph.nodeWidth + widthMultiplier * MARGIN_BETWEEN_BRANCH_NODES;
  return nodeWrapperWidth;
};
export default getNodeWrapperWidth;